import "./home.css";

function Home() {
  return <div className="home-page">Home</div>;
}

export default Home;
